'use client';
import React__default from 'react';
import PropTypes from 'prop-types';
import { Modal } from './Modal.js';
import { ModalFooter } from './Modal.styles.js';
import { ModalHeader } from './ModalHeader.js';
import { ModalContent } from './ModalContent.js';
import Button from '../Inputs/Button/Button.js';
import ButtonIcon from '../Inputs/Button/ButtonIcon/ButtonIcon.js';
import { BUTTON_VARIANT, BUTTON_SIZE } from '../Inputs/Button/Button.constants.js';

var defaultProps = {
  cancelLabel: 'Cancel',
  confirmButtonVariant: BUTTON_VARIANT.PRIMARY,
  confirmLabel: 'Confirm',
  isDisabledCancel: false,
  isDisabledConfirm: false,
  isDisabledEscape: false,
  isOpen: false,
  isPendingConfirm: false,
  onCancel: null,
  onEscape: null,
  testId: undefined
};
var ConfirmationDialog = React__default.forwardRef(function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultProps;
  var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var cancelLabel = props.cancelLabel,
    children = props.children,
    confirmButtonVariant = props.confirmButtonVariant,
    confirmLabel = props.confirmLabel,
    id = props.id,
    isDisabledCancel = props.isDisabledCancel,
    isDisabledConfirm = props.isDisabledConfirm,
    isDisabledEscape = props.isDisabledEscape,
    isPendingConfirm = props.isPendingConfirm,
    isOpen = props.isOpen,
    onCancel = props.onCancel,
    onConfirm = props.onConfirm,
    onEscape = props.onEscape,
    title = props.title,
    testId = props.testId;
  return React__default.createElement(Modal, {
    id: id,
    isDisabledEscape: isDisabledEscape,
    isOpen: isOpen,
    onCancel: onCancel,
    onConfirm: onConfirm,
    onEscape: onEscape,
    ref: ref,
    testId: testId
  }, React__default.createElement(ModalHeader, {
    id: id
  }, title, onCancel && React__default.createElement(ButtonIcon, {
    icon: "Close",
    variant: BUTTON_VARIANT.GHOST,
    size: BUTTON_SIZE.SMALL,
    title: cancelLabel,
    onClick: onCancel,
    disabled: isDisabledCancel
  }, cancelLabel)), React__default.createElement(ModalContent, null, children), React__default.createElement(ModalFooter, null, onCancel && React__default.createElement(Button, {
    onClick: onCancel,
    variant: BUTTON_VARIANT.GHOST,
    isDisabled: isDisabledCancel
  }, cancelLabel), React__default.createElement(Button, {
    onClick: onConfirm,
    variant: confirmButtonVariant,
    isDisabled: isDisabledConfirm,
    isPending: isPendingConfirm
  }, confirmLabel)));
});
ConfirmationDialog.defaultProps = defaultProps;
ConfirmationDialog.propTypes = {
  cancelLabel: PropTypes.string,
  children: PropTypes.node.isRequired,
  confirmButtonVariant: PropTypes.oneOf(Object.values(BUTTON_VARIANT)),
  confirmLabel: PropTypes.string,
  id: PropTypes.string.isRequired,
  isDisabledCancel: PropTypes.bool,
  isDisabledConfirm: PropTypes.bool,
  isDisabledEscape: PropTypes.bool,
  isOpen: PropTypes.bool,
  isPendingConfirm: PropTypes.bool,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func.isRequired,
  onEscape: PropTypes.func,
  testId: PropTypes.string,
  title: PropTypes.string.isRequired
};

export { ConfirmationDialog };
//# sourceMappingURL=ConfirmationDialog.js.map
